import Controller from "@ember/controller"
import { computed, get } from "@ember/object"
import { equal } from "@ember/object/computed"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import moment from "cc-frontend/utils/extended-moment"
import _ from "lodash"
import findDocument from "../../helpers/find-document"
import hasManyCollectively from "../../helpers/has-many-collectively"

export default class PlanbookDateController extends Controller {
  @service("ember-store")
  store

  queryParams = [
    "startDate",
    "endDate",
    "classesLinedUp",
    "isFilteringClasses",
    "courseIds",
    "asColumns",
    "headerText",
    "showComments",
    "showStandardDescriptions",
    "isFilteringCards",
    "visibleCards",
    "pageBreaks",
  ]

  classesLinedUp = true
  asColumns = false
  isFilteringClasses = false
  courseIds = []
  showComments = false
  showStandardDescriptions = true
  isFilteringCards = false
  visibleCards = []
  pageBreaks = "none"

  @findDocument("model.planbookId", "planbook") planbook
  @hasManyCollectively("planbook", "course", "courses") courses
  @belongsTo("planbook", "rotationCalendar") rotationCalendar

  @equal("pageBreaks", "after-day") pageBreakAfterDay
  @equal("pageBreaks", "after-class") pageBreakAfterClass

  @computed("pageBreaks")
  get normalPageBreaks() {
    return get(this, "pageBreaks") === "none" || get(this, "pageBreaks") === ""
  }

  @computed(
    "isFilteringClasses",
    "planbook.content.relationships.courses.data.@each.id",
    "courses.isPending",
    "courses.content"
  )
  get visibleCourses() {
    if (get(this, "courses.isPending") === true) return []
    let isFiltering = get(this, "isFilteringClasses")
    if (isFiltering === true) {
      return _.compact(
        _.map(get(this, "courseIds"), (id) =>
          _.find(get(this, "courses.content"), (course) => get(course, "id") === id)
        )
      )
    } else {
      return _.map(get(this, "courses.content"), (course) => course)
    }
  }

  @computed("startDate", "endDate", "rotationCalendar.content.attributes.schoolDays")
  get dateStrings() {
    let validSchoolDays = get(this, "rotationCalendar.content.attributes.schoolDays")

    let startDate = get(this, "startDate")
    let endDate = get(this, "endDate")

    let range = moment.range(startDate, endDate)
    let acc = []
    Array.from(range.by("days")).map((moment) => {
      if (_.includes(validSchoolDays, moment.weekday())) acc.push(moment)
    })
    let newDates = _.uniq(_.map(acc, (m) => m.format("YYYY-MM-DD")))

    return newDates
  }

  @computed("dateStrings.[]")
  get perspective() {
    return this.dateStrings.length > 1 ? "week" : "day"
  }

  @computed("dateStrings.[]")
  get dateRangeString() {
    var start = moment(get(this, "dateStrings.firstObject"))
    var end = moment(get(this, "dateStrings.lastObject"))
    var startMonth = start.format("MMMM")
    var endMonth = end.format("MMMM")
    if (get(this, "dateStrings.firstObject") === get(this, "dateStrings.lastObject")) {
      return start.format("MMMM D, YYYY")
    } else if (startMonth === endMonth) {
      return start.format("MMMM D") + " - " + end.format("D, YYYY")
    } else {
      return start.format("MMM. D") + " - " + end.format("MMM. D, YYYY")
    }
  }
}
